// App.js
import { useEffect, useState } from 'react';
import { Routes, Route,useNavigate } from 'react-router-dom';
import Loader from './components/Loader';
import Login from './pages/Login';
import VerifyOTP from './pages/VerifyOtp';
import Home from './pages/Home';

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [step, setStep] = useState('login'); // 'login', 'otp', 'home'
  const [phoneNumber, setPhoneNumber] = useState('');
  const [otp, setOtp] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) return <Loader />;

  return (
    <>
    <div className="app-container">
      <Routes>
        {/* <Route path="/" element={<Navigate to="/login" />} /> */}
        <Route path="/mobile" element={<Login setPhoneNumber={setPhoneNumber} setOtp={setOtp} />} />
        <Route path="/mobile/OTP-verification" element={<VerifyOTP  phoneNumber={phoneNumber} OTP={otp} />} />
        <Route path="/mobile/home" element={<Home />} />
      </Routes>  
    </div>
    </>
  );
}

export default App;
